import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FilterEngineV2Component, ToolbarV2Module } from '@iot-platform/iot-platform-ui';
import { MasterViewEngineModule } from '@iot-platform/table-engine';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TranslatePipe } from '@ngx-translate/core';
import { AssetsRoutingModule } from './assets-routing.module';
import { AssetsShellComponent } from './containers/assets-shell/assets-shell.component';
import { AssetsEffects } from './state/effects/assets.effects';
import * as fromAssets from './state/reducers';

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    TranslatePipe,
    ToolbarV2Module,
    MasterViewEngineModule,
    AssetsRoutingModule,
    StoreModule.forFeature(fromAssets.featureKey, fromAssets.reducers),
    EffectsModule.forFeature([AssetsEffects]),
    FilterEngineV2Component
  ],
  declarations: [AssetsShellComponent]
})
export class AssetsModule {}
